/**
 * author: 582196894@qq.com
 * date: 2020/06/12
 * desc: 用户信息
 * demo:
 * User.getUserInfo({
 *  force: false
 * })
 * 返回，注意事项
 * 1 IOS,Android,H5返回的数据结构一致
 * 2 用户是否登录根据 islogin字段判断
 *
 * {
 *  islogin: true,
 *  userid: "115d52a7-cb3e-4070-811f-64c8d6aa135c",
 *  phone: "13921745521",
 *  name: "wahaha",
 *  usersession: "206eb5e212cd4136bb711fdc9b1c08df"
 * }
 */
/** 接口配置 */
// import Cookies from 'js-cookie'
import config from '@/configs/config'

const USER_INFO_URL = `${config.apis.GET_USERINFO}`

const LOGOUT = `${config.apis.LOG_OUT}`

const GET_OUT_URL = `${config.apis.WX_SILENT}`

const USER_STORAGE_KEY = '_xk_user_key'

let userInfoPromise = null

function resetData(data) {
  if (!data || !data.userId) {
	return { islogin: false }
  }

  const userId = (data.userId || data.userid || data.userID || '').replace(/[{}]/g, '')
  if (!userId) {
    data.islogin = false
  } else {
    data.islogin = true
  }

  return data
}

const uuid = (function() {
  const key = '_login_uuid'
  let uuid = ''

  return function () {
    if (!uuid) {
      uuid = tuhu.localStorage.getItem(key)
    }

    if (uuid) {
      return uuid
    }

    let d = new Date().getTime()
    uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16)
    })

    tuhu.localStorage.setItem(key, uuid)
    return uuid
  }
})()

class User {
  static uuid = uuid

  static clearUserInfoPromise() {
    userInfoPromise = null
  }

  static getUserInfo(options = {}) {
    options = Object.assign({
      direct: false,
      force: false,
      phone: ''
    }, options)
    return new User(options).getUserInfo()
  }

  static setUserInfo(data) {
    if (!data) {
      userInfoPromise = null
      tuhu.localStorage.removeItem(USER_STORAGE_KEY)

      tuhu.store && tuhu.store.commit('setUserInfo', {islogin: false})

      tuhu.localStorage.clear()

	  tuhu.fetch(`${LOGOUT}`)
	//   Cookies.set('x-auth-token', '')
	//   return tuhu.navigateTo({
	// 	  url: '/pages_login/index'
	//   })
    }

	const result = resetData(data)

    tuhu.store && tuhu.store.commit('setUserInfo', result)

    userInfoPromise = Promise.resolve(result)

    try {
	  tuhu.localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(result))
    } catch (e) {
		console.log(e)
    }

    return userInfoPromise
  }

  constructor(options) {
    this.options = options
  }

  _getH5Promise() {
	this.showLoading()

    return tuhu.fetch(`${USER_INFO_URL}`).catch((e) => {
	  this.hideLoading()
      return {
        islogin: false
      }
	})
  }

  showLoading () {
	tuhu.showIndicator()
  }

  hideLoading() {
	tuhu.hideIndicator()
  }

  getUserInfo() {
    if (!userInfoPromise) {
      userInfoPromise = this._getH5Promise()

      userInfoPromise = userInfoPromise
      .then(data => {
		  if (data && data.code === '200') {
			return resetData(data.data)
		  } else {
			return resetData()
		  }
	  })
      .catch((e) => {
		console.error(e)
		this.hideLoading()

        userInfoPromise = null

        return {
          islogin: false
        }
      })
    }

    userInfoPromise = userInfoPromise
    .then((userInfo) => {
      tuhu.store && tuhu.store.commit('setUserInfo', userInfo)
      return userInfo
    })
    .then((result) => {
      if (!result.islogin) {
        if (!tuhu.device.isApp && process.env.NODE_ENV !== 'development') {
          tuhu.localStorage.removeItem(USER_STORAGE_KEY)
        }
        if (this.options.force) {
          // openId 只有后端（无次用户）重定向登陆页有
          if (tuhu.device.isWeixin && !this.options.openId && (location.href.indexOf('localhost') === -1)) {
            location.href = `${GET_OUT_URL}?url=${encodeURIComponent(location.href)}&source=3`
          } else {
            return new Promise((resolve, reject) => {
              tuhu.navigateTo({
                url: '/pages/_login/index',
                query: {
                  direct: this.options.direct ? 1 : '',
                  phone: this.options.phone || '',
                  openId: this.options.openId || ''
                },
                data: {
                  resolve: resolve
                }
              })
            })
          }
        }
      }

      return result
    })
    // .then(async (result) => {
    //   return result
    // })
    return userInfoPromise
  }
}

export default User



// WEBPACK FOOTER //
// ./lib/commons/user.js